import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WhitelabelImageWebComponent } from '@resident-nx/web/ui';
import { WhitelabelImage, WhitelabelImageAltTag } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-success-screen',
  imports: [TranslateModule, WhitelabelImageWebComponent],
  templateUrl: './success-screen.component.html',
  styleUrl: './success-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessScreenWebComponent {
  public readonly WhitelabelImage = WhitelabelImage;
  public readonly WhitelabelImageAltTag = WhitelabelImageAltTag;
}
